import { PaymentMethod } from 'types/PaymentMethod';

export const hasValidCardOnFile = (paymentMethods: Array<PaymentMethod>): boolean =>
    paymentMethods.some(card => !card.expired);
